import React from "react";
import { useEffect,useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Navigate, useNavigate, useOutletContext } from "react-router-dom";
import { useSelector } from "react-redux";
import MbpAthnUi, { MbpAthnUiWithGameSvcCd } from "Utils/MbpAthn";
import MgpStore from "Stores/Store";
import MembGameLvdSvcMnyLpopUi from "./MembGameLvdSvcMnyLpopUi";
import MembGameRelLstApi from "Apis/MembGameRelLstApi";
import GameSvcLinkApi from "Apis/GameSvcLinkApi";
import GameSvcRsvdApi from "Apis/GameSvcRsvdApi";
import "Assets/css/MembGameRelLst.css";
import { de } from "date-fns/locale";
import MembAccnDtlInfoInqApi from "Apis/MembAccnDtlInfoInqApi";
import MbpAthnRsltVrfRqstApi from "Apis/MbpAthnRsltVrfRqstApi";
import GameScndPasswdChngApi from "Apis/GameScndPasswdChngApi";
import ApiResultModal from "Components/ApiResultModal";

// 현재 인증 처리 중인 게임 서비스 코드 (전역 변수로 즉시 반영)
let currentAuthGameSvcCd = "";



const MembGameSvcRelUi = () => {
    const navigate = useNavigate();
    const idntMthdCd = useSelector((state: any) => state.IdntMthdCdState?.IdntMthdCd);
    const [membGameYrelLstState,setMembGameYrelLstState] = useState([]);
    const [membGameNrelLstState,setMembGameNrelLstState] = useState([]);
    const [emlAthnPrpsCd] =useState("SCND_PWD_RSET");
    const [resultModalOpen, setResultModalOpen] = useState(false);
    const [resultModalMessage, setResultModalMessage] = useState("");

    const openResultModal = (message: string) => {
        setResultModalMessage(message);
        setResultModalOpen(true);
    };

    const closeResultModal = () => {
        setResultModalOpen(false);
    };
    
    var popupX = Math.round(window.screenX + (window.outerWidth/2) - (500/2));
    var popupY = Math.round(window.screenY + (window.outerHeight/2) - (765/2));
    const GameMnyPopFunc = (e:any)=>{
        window.open(e,"_blank","width=500,height=765 left="+popupX+"top="+popupY);
    }
    const EmlAthnPopFunc = (e:any)=>{
        window.open(e,"_blank","width=550,height=800 left="+popupX+"top="+popupY);
    }
    const langData:any = useOutletContext();
    useEffect(()=>{
        MembGameRelLstApi().then((resp)=>(
            setMembGameYrelLstState(resp.yrelLst),
            setMembGameNrelLstState(resp.nrelLst)
        ));

        function kmcRespFunc (kmcApiTknrslt:string,kmcApiCertNumrslt:string){
            
            MbpAthnRsltVrfRqstApi(kmcApiTknrslt,kmcApiCertNumrslt)
            .then((resp) => {
                if(resp.apiHdr.code == "ATHN0000") {
                    GameScndPasswdChngApi(currentAuthGameSvcCd).then((resp)=>{
                        // 2차 비밀번호 재설정 성공 처리
                        openResultModal(langData && langData.MYPAGE_SCND_PASSWD_INIT_SUCCESS_00 || '2차 비밀번호가 재설정되었습니다.');
                        // 처리 완료 후 초기화
                        currentAuthGameSvcCd = "";
                    }).catch((error) => {
                        console.error('2차 비밀번호 재설정 실패:', error);
                        openResultModal(langData && langData.MYPAGE_SCND_PASSWD_INIT_FAIL_00 || '2차 비밀번호 재설정에 실패했습니다.');
                        currentAuthGameSvcCd = "";
                    });
                }
                if(resp.apiHdr.code == "ATHN2312") {
                    openResultModal(langData&&langData.GLB_ATHN_FAIL_LBL_00);
                    // 인증 실패 시에도 초기화
                    currentAuthGameSvcCd = "";
                }
            });
        }
        window.kmcRespFunc = kmcRespFunc;
        const emlAthnRespFunc =() => {
            
            if (!currentAuthGameSvcCd) {
                openResultModal(langData && langData.MYPAGE_GAME_SVC_CD_NOT_SET_00 || '게임 서비스 코드가 설정되지 않았습니다.');
                return;
            }
            GameScndPasswdChngApi(currentAuthGameSvcCd).then((resp)=>{
                // 2차 비밀번호 재설정 성공 처리
                openResultModal(langData && langData.MYPAGE_SCND_PASSWD_INIT_SUCCESS_00 || '2차 비밀번호가 재설정되었습니다.');
                // 처리 완료 후 초기화
                currentAuthGameSvcCd = "";
            }).catch((error) => {
                console.error('2차 비밀번호 재설정 실패:', error);
                openResultModal(langData && langData.MYPAGE_SCND_PASSWD_INIT_FAIL_00 || '2차 비밀번호 재설정에 실패했습니다.');
                currentAuthGameSvcCd = "";
            });
        }
        window.emlAthnRespFunc = emlAthnRespFunc;

    },[MgpStore.getState().LangSetState.Lang])
    const GameSvcLinkFunc = (gameSvcCd:string,gameSttuCd:string) => {
        switch(gameSttuCd) {
            case "RLS":   
            GameSvcLinkApi(gameSvcCd).then((resp)=>{
                openResultModal(`${langData&&langData.MYPAGE_GAME_REL_SESS_DESC_00}`);
                MembGameRelLstApi().then((resp)=>(
                    setMembGameYrelLstState(resp.yrelLst),
                    setMembGameNrelLstState(resp.nrelLst)
                ));
            })
            .catch((error)=>{
                if(error.response.status == 401) {
                    
                    return navigate("/Login?lang="+MgpStore.getState().LangSetState.Lang);
                }else {
                    openResultModal(`${langData&&langData.MYPAGE_GAME_REL_FAIL_DESC_00}`);
                }
            });
            break;
            case"RSVD":
            GameSvcRsvdApi(gameSvcCd).then((resp)=>{
                if(resp.apiHdr.code == "ATHN2014") {
                    openResultModal(`${langData&&langData.MYPAGE_GAME_RSVD_SESS_DESC_00}`);
                }else {
                    openResultModal(`${langData&&langData.MYPAGE_GAME_RSVD_FAIL_DESC_00}`);
                }
            });
            break;
            default:
            openResultModal(`${langData&&langData.MYPAGE_GAME_REL_FAIL_DESC_00}`);  
        }
        MembGameRelLstApi().then((resp)=>(
            setMembGameYrelLstState(resp.yrelLst),
            setMembGameNrelLstState(resp.nrelLst)
        ));
    }
    return(
        <>
        <ApiResultModal
            open={resultModalOpen}
            message={resultModalMessage}
            onClose={closeResultModal}
confirmText={langData&&langData.COMM_MAIN_CHK_MAIN_BTN_00}
        />
        <Helmet>
            <title>{`${process.env.REACT_APP_TITLE_PREFIX} ${langData&&langData.MYPAGE_MENU_GAME_REL_BTN_00}`}</title>
        </Helmet>
        <div className="container1300">
            <div className="myPageSubTitlWrap">
                <p className="myPageCtxtTitl">{langData&&langData.MYPAGE_MENU_GAME_REL_BTN_00}</p>
            </div>
            {membGameYrelLstState&&membGameYrelLstState.length != 0 ?
                <div className="myPageSubCtxtWrap">
                    <div className="RelLstTitlWrap">
                        <h1>{langData&&langData.MYPAGE_GAME_REL_PAGE_TITL_00}</h1>
                        <p>{langData&&langData.MYPAGE_GAME_REL_MAIN_DESC_00}</p>
                    </div>
                    <div className="membGameSvcRelCardWrap membGameSvcRelPageWrap">
                        <ul>
                            {membGameYrelLstState&&membGameYrelLstState.map((key:any) =>(
                                <li className="membGameSvcRelCard">
                                    <div className="gameSvcThmbImgWrap">
                                        <img src={key.thmbUrl} alt="" />
                                    </div>
                                    {key.gameSttuCd == "RLS" ?
                                        <div className="membGameSvcRelCardTextWrap">
                                            <div className="gameSvcTitl">
                                                <h1>{key.gameNm}</h1>
                                                <div className="dFlex mt5 gap3">
                                                    <p>{langData&&langData.MYPAGE_GAME_REL_DTIME_LBL_00}</p>
                                                    <p>{key.joinDtime}</p>
                                                </div>
                                            </div>
                                            <div className="membGameSvcRelDtimeWrap">                                            
                                                <div className="mainMnyWrap dFlex">
                                                    <p>{key.gameMnyNm}</p>
                                                    <p>{key.totMny}</p>
                                                </div>
                                                <div className="subMnyArea">
                                                    <div className="subMnyWrap dFlex">                                            
                                                        <p>{langData&&langData.MYPAGE_MAIN_GAME_MNY_LBL_01} {key.gameMnyNm}</p>
                                                        <p>{key.paidMny}</p>
                                                    </div>
                                                    <div className="subMnyWrap dFlex">                                            
                                                        <p>{langData&&langData.MYPAGE_MAIN_GAME_MNY_LBL_02} {key.gameMnyNm}</p>
                                                        <p>{key.freeMny}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="dFlex gap15">
                                                {key.scndPasswdUseYn == "Y" ?
                                                    <>
                                                        {MgpStore.getState().IdntMthdCdState.IdntMthdCd === "EML"?
                                                            <button onClick={() => {
                                                                currentAuthGameSvcCd = key.gameSvcCd;
                                                                EmlAthnPopFunc(`${'/EmlAthnPop?emlAthnPrpsCd=' + emlAthnPrpsCd + "&lang=" +MgpStore.getState().LangSetState.Lang}`);
                                                            }}>
                                                                <span>{langData&&langData.MYPAGE_SCND_PASSWD_INIT_BTN_00}</span>
                                                                {/* 인증하기 */}
                                                            </button>
                                                            :
                                                            <MbpAthnUiWithGameSvcCd 
                                                                athnPrpsCd='SCND_PWD_RSET' 
                                                                AthnTxt={langData&&langData.MYPAGE_SCND_PASSWD_INIT_BTN_00}
                                                                gameSvcCd={key.gameSvcCd}
                                                                onGameSvcCdSet={(gameSvcCd: string) => { currentAuthGameSvcCd = gameSvcCd; }}
                                                            />
                                                        }
                                                    </>
                                                    :
                                                    <></>
                                                }
                                                <Link className="gameMnyPopBtn" to={`/GamePage/ShopLst?gameSvcCd=${key.gameSvcCd}&shopKindCd=MNY`}>{langData&&langData.MYPAGE_MAIN_MNY_DPST_BTN_00}</Link>
                                                {/* <button className="gameMnyPopBtn" onClick={()=>GameMnyPopFunc(`/GameMnyDpstPop?lang=${MgpStore.getState().LangSetState.Lang}`)}>{langData&&langData.MYPAGE_MAIN_MNY_DPST_BTN_00}</button> */}
                                            </div>
                                        </div>:
                                        <div className="membGameSvcRelCardTextWrap">
                                            <div className="gameSvcTitl">
                                                <h1>{key.gameNm}</h1>
                                                <div className="dFlex mt5 gap3">
                                                    <p>{langData&&langData.MYPAGE_GAME_REL_DTIME_LBL_01}</p>
                                                    <p>{key.rsvdDtime}</p>
                                                </div>
                                            </div>
                                            <div className="membGameSvcRelDtimeWrap">                                            
                                                <div className="mainMnyWrap dFlex">
                                                    <p>{langData&&langData.MYPAGE_GAME_OPEN_DTIME_LBL_00}</p>
                                                </div>
                                                <div className="subMnyArea">
                                                    <div className="subMnyWrap dFlex">                                            
                                                        <p>{key.paidMny}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="dFlex gap15">
                                                <Link className="gameMnyPopBtn" to={`/gamepage?gameSvcCd=${key.gameSvcCd}`}>{langData&&langData.MYPAGE_MAIN_GAME_PAGE_BTN_00}</Link>
                                            </div>
                                        </div>

                                    }
                                </li>
                            ))}
                        </ul>
                    </div>
                </div> 
                :
                <></>
            }
            <div className={membGameYrelLstState&&membGameYrelLstState.length != 0 ?"myPageSubCtxtWrap pb70":"myPageSubCtxtWrap"}>
                <div className={membGameYrelLstState&&membGameYrelLstState.length != 0 ?"RelLstTitlWrap mt40":"RelLstTitlWrap"}>
                    <h1>{langData&&langData.MYPAGE_REL_N_LST_TITL_00}</h1>
                    <p>{langData&&langData.MYPAGE_REL_N_LST_DESC_00}</p>
                </div>
                <div className="membGameSvcRelCardWrap membGameSvcRelPageWrap">
                    <ul>
                        {membGameNrelLstState&&membGameNrelLstState.map((key:any) =>(
                            <li className="membGameSvcRelCard">
                                <div className="gameSvcThmbImgWrap">
                                    <img src={key.thmbUrl} alt="" />
                                </div>
                                <div className="membGameSvcRelCardTextWrap">
                                    <div className="gameSvcTitl">
                                        <h1>{key.gameNm}</h1>
                                    </div>
                                    {/* <div className="membGameSvcRelDtimeWrap">
                                        <p>{langData&&langData.MYPAGE_GAME_REL_DTIME_LBL_00}</p>
                                        <p>{key.joinDtime}</p>
                                    </div> */}
                                    <div>
                                        {key.gameSttuCd == "RLS" ?
                                            <button onClick={() => GameSvcLinkFunc(key.gameSvcCd,key.gameSttuCd)}>{langData&&langData.MYPAGE_GMAE_REL_MAIN_BTN_00}</button>
                                            :
                                            <button onClick={() => GameSvcLinkFunc(key.gameSvcCd,key.gameSttuCd)}>{langData&&langData.MYPAGE_GMAE_REL_MAIN_BTN_01}</button>
                                            
                                        }
                                    </div>
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
            </div> 
        </div>
        </>
    )
}

export default MembGameSvcRelUi;